<template>
  <v-currency-field
    v-bind="$attrs"
    :decimal-length="decimalLength"
    :locale="locale"
    :maxlength="currencyFieldMaxLength"
    :allow-negative="allowNegative"
    :default-value="null"
    v-on="$listeners"
    @input.native="handleInput($event)"
  />
</template>

<script>
import { VCurrencyField } from 'v-currency-field';

export default {
  name: 'currency-field',
  components: { VCurrencyField },
  props: {
    decimalLength: {
      type: Number,
      default: 0,
    },
    locale: {
      type: String,
      default: 'en-gb',
    },
    allowNegative: {
      type: Boolean,
      default: false,
    },
    maxlength: {
      type: [Number, null],
      default: null,
    },
  },
  data () {
    return {
      fieldMaxLength: 0,
    };
  },
  computed: {
    currencyFieldMaxLength: {
      get () {
        return this.fieldMaxLength || this.maxlength;
      },
      set (value) {
        this.fieldMaxLength = value;
      },
    },
  },
  mounted () {
    this.deleteDuplicatedDataTestAttribute();
  },
  methods: {
    handleInput (event) {
      const value = event.target.value;

      // Get amount of separators for dynamic counting of maxlength property.
      // Amount of separators not influence on final value.
      const separatorsAmount = value?.split('').filter(item => !item.match(/^[0-9]+$/)).length;

      this.fieldMaxLength = this.maxlength + separatorsAmount;
    },
    deleteDuplicatedDataTestAttribute () {
      const attrName = 'data-test';
      const parent = this.$el.closest(`[${attrName}]`);
      parent.removeAttribute(attrName);
    },
  },
};
</script>
